'use client';

import { useEffect } from 'react';

import { initAlgoliaTracking } from '@libs/analytics';

import { useInitPurchaseForm } from '@/entities/purchase-form';

import { useChangeDeliveryMethodAnalytics } from './analytics';
import { useSubmit } from './submit';
import { useApplyRecommendedAutoshipFrequency } from './useApplyRecommendedAutoshipFrequency';
import { useGetDefaultValues } from './useGetDefaultValues';
import { usePurchaseValidation } from './usePurchaseValidation';
import { useSelectDeliveryMethod } from './useSelectDeliveryMethod';
import { useUpdateStores } from './useUpdateStores';

export const usePurchaseForm = () => {
    const defaultValues = useGetDefaultValues();
    const form = useInitPurchaseForm({ defaultValues });

    const { submitHandler } = useSubmit();

    // Select correct delivery method based on purchase option and delivery methods data.
    useSelectDeliveryMethod();
    useApplyRecommendedAutoshipFrequency();
    useChangeDeliveryMethodAnalytics(form);

    useEffect(() => {
        void initAlgoliaTracking();
    }, []);

    // Validate one-time and autoship purchase
    usePurchaseValidation();

    // Update stores when form state changes
    useUpdateStores({ formControl: form.control });

    return { ...form, submitHandler };
};
